import {router} from "@inertiajs/react";
import {route} from "ziggy-js";

export const fetchArticle = (source, params, options = {}) => {
    return router.post(
        route( `${source}.post`),
        params,
        {
            preserveScroll: true,
            ...options,
        }
    );
};
